export enum TrunkState {
    NeverConnected,
    Connected,
    Reconnected,
    Disconnected,
    DisconnectedClient
}